<template>
  <div>
    <div ref="chart" style="width: 1600px; height:400px; margin-left: 100px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from "axios";
export default {
  data() {
    return {
      chart: null,
      salesData: [],
    };
  },
  mounted() {
    this.fetchSalesData();
  },
  methods: {
    fetchSalesData() {
      // 模拟异步请求
      axios.get('http://localhost:8090/mer/getYinYeE') // 假设这是你的API路径
        .then(response => {
          const responseData = response.data.data;
          this.salesData = responseData.map(item => ({
            day: item.day,
            money: item.money
          }));
          this.initChart();
        })
        .catch(error => console.error('Error fetching sales data:', error));
    },
    initChart() {
      if (this.chart) {
        this.chart.dispose(); // 销毁旧的图表实例
      }
      this.chart = echarts.init(this.$refs.chart);

      const daysOfWeek = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
      const sortedData = Array(7).fill({ day: 0, money: 0 });
      this.salesData.forEach(item => {
        if (item.day >= 1 && item.day <= 7) {
          sortedData[item.day - 1] = { day: item.day, money: item.money };
        }
      });

      const option = {
        title: {
          text: '本周营业额'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: daysOfWeek
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: sortedData.map(item => item.money),
          type: 'line'
        }]
      };

      this.chart.setOption(option);
    }
  }
};
</script>

<style scoped>
/* 添加一些样式 */
</style>